/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTCarousel } from './carousel';
export type {
	KTCarouselChangePayloadInterface,
	KTCarouselConfigInterface,
	KTCarouselInterface,
} from './types';
